module.exports = require("jaeger-client");